/**
 * RiskConsequence integration — create/delete for risk detail flows (no list page store).
 */
import i18next from 'i18next';
import { toast } from 'sonner';
import { ApiError } from '@repo/sdk';

export class RiskConsequenceIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    _getErrorMessage(error) {
        if (error instanceof ApiError) return error.message;
        return error.message || 'An error occurred';
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('integrationToasts:resultRecordCreated', { defaultValue: 'Result record created' }));
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async delete(id) {
        try {
            const response = await this.service.delete(id);
            toast.success(i18next.t('integrationToasts:resultRecordDeleted', { defaultValue: 'Result record deleted' }));
            return { success: true };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
